var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatar8 = function SvgDefaultAvatar8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "default-avatar_8_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".default-avatar_8_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9 55.7c6.6 0 11-3.7 11-8.9 0-3.6-2.1-6-6.3-8 3.6-1.6 5.2-4 5.2-6.7 0-4.2-3.4-7.5-9.6-7.5-6.5 0-10 3.7-10 8 0 3.1 2 5.5 4.9 7.1-3.9 1.7-5.9 4.5-5.9 7.7-.1 4.7 4.3 8.3 10.7 8.3zm-6.8-8.8c0-2.5 1.6-4.7 5-5.9 4.8 1.8 8.4 3.2 8.4 6.8 0 3.5-3.3 5.1-6.5 5.1-4.2-.1-6.9-2.7-6.9-6zm1.5-15.3c0-2.7 2.5-4.2 5.3-4.2 4.2 0 6 2.1 6 4.8 0 2.1-1.3 4.1-4.5 5.2-3.8-1.4-6.8-2.8-6.8-5.8z"
  })));
};
export default SvgDefaultAvatar8;